import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { company } from '~/company/Company';
import { Button } from '~/components/isolated/Button';
import Typography, { VARIANT } from '~/components/isolated/Typography';

import styles from './EmptyCartV3.module.scss';

/**
 * Empty cart component for CartV3
 * Displayed when user has no items in the cart
 */
const EmptyCartV3 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoShopping = () => {
    navigate('/shop');
  };

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <img src={company.images.cart.empty} className={styles.icon} alt="" />
      </div>
      <Typography
        as="h2"
        variant={VARIANT['Header 150/Light']}
        className={styles.title}
      >
        {t('emptyCart')}
      </Typography>
      <Button
        className={styles.button}
        variant="primary"
        size={company.match({
          mcosmetic: 'L',
          default: 'XL',
        })}
        onClick={handleGoShopping}
      >
        {t('goShopping')}
      </Button>
    </div>
  );
};

export default EmptyCartV3;
